import { getHeadingStructureSuggestion } from '@wix/ambassador-promote-seo-v1-heading-fix/http';
export const fetchHeadingStructureSuggestions = async (httpClient, errorHandler, request) => {
  const {
    data
  } = await errorHandler.withErrorHandler(async () => httpClient.request(getHeadingStructureSuggestion(request)), {
    errorCodesMap: {
      applicationError: {}
    }
  });
  return data;
};
//# sourceMappingURL=heading-structure-suggestions-api.js.map